import gql from "graphql-tag";

const ORGANIZATION_MEMBERS_QUERY = gql`
  query organizationMembers($where: GetOrganizationWhereInput!) {
    organization(where: $where) {
      id
      name
      members {
        id
        user {
          id
          email
          professional {
            type
            locations {
              city
              country
              residence
              street1
              street2
              postal
              fax
              email
              phone
            }
            profile {
              firstName
              middleName
              lastName
              email
              fax
            }
          }
        }
      }
    }
  }
`;

export default ORGANIZATION_MEMBERS_QUERY;
